import * as React from 'react';
import onClickOutside from 'react-onclickoutside';

import { OpenArrowButton } from '../active-button';
import { Text } from '../texts';
import Waves from '../waves';
import { DropdownList } from './dropdown-list';
import { Styled } from './styled';

class DropdownInputComponent extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = { isDropdownOpen: false };

    this.toggleDropDawnOpen = this.toggleDropDawnOpen.bind(this);
    this.selectFromDropDawn = this.selectFromDropDawn.bind(this);
  }

  render() {
    const {
      header,
      elements,
      activeElementIndex,
      tooltips,
      disabled,
      backgroundColor,
      borderRadius,
      maxItemsAmount = 4,
    } = this.props;
    const activeElement = elements[activeElementIndex];

    return (
      <Styled.DropDownContainer
        borderRadius={borderRadius}
        disabled={disabled}
        backgroundColor={backgroundColor}
        withHeader={header}
        isDropdownOpen={this.state.isDropdownOpen}
        onClick={this.toggleDropDawnOpen}
      >
        <Styled.SelectedContent borderRadius={borderRadius}>
          <Styled.TextsContainer withHeader={header}>
            {header && <Styled.Header value={true}>{header}</Styled.Header>}
            <Text>{activeElement}</Text>
          </Styled.TextsContainer>
          <OpenArrowButton isOpen={this.state.isDropdownOpen} />
        </Styled.SelectedContent>
        <Waves />
        {this.state.isDropdownOpen && (
          <DropdownList
            borderRadius={borderRadius}
            filteredElements={elements}
            activeElements={[activeElement]}
            activeElementIndex={activeElementIndex}
            maxItemsAmount={maxItemsAmount}
            tooltips={tooltips}
            onClick={this.selectFromDropDawn}
          />
        )}
      </Styled.DropDownContainer>
    );
  }

  toggleDropDawnOpen(e) {
    this.setState({ isDropdownOpen: !this.state.isDropdownOpen });
    e.stopPropagation();
  }

  selectFromDropDawn(event, index) {
    const {
      elements,
      onClick,
      afterClick = () => {},
      closeAfterClick = false,
      additionalParams,
    } = this.props;
    onClick(
      additionalParams
        ? { newValue: elements[index], ...additionalParams }
        : index
    );
    closeAfterClick && this.setState({ isDropdownOpen: false });
    afterClick();
    event.stopPropagation();
  }

  handleClickOutside = () => this.setState({ isDropdownOpen: false });
}

export const DropdownInput = onClickOutside(DropdownInputComponent);
